import { useState } from "react";
import { DatabaseZap, Loader2, PlugZap } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { usePoll } from "@/hooks/usePoll";
import { api, admin, errMsg, get } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

export const MaintenanceTab = ({ pw }) => {
  const { data: meta, refresh } = usePoll(() => get("/instruments/meta"), 0, []);
  const [busy, setBusy] = useState("");
  const run = async (name, url, msg) => {
    setBusy(name);
    try {
      await api.post(url, null, admin(pw));
      toast.success(msg);
      refresh();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy("");
    }
  };
  return (
    <div className="space-y-4 pt-3" data-testid="maintenance-tab">
      <div className="rounded border border-slate-800 bg-slate-950/40 p-3 font-mono text-xs text-slate-400" data-testid="instrument-meta">
        Instrument master: <span className="text-slate-100">{meta?.count ?? "—"}</span> rows · source{" "}
        <span className="text-slate-100">{meta?.source ?? "—"}</span> · synced {fmtDateTime(meta?.synced_at)}
      </div>
      <div className="flex flex-wrap gap-2">
        <Button data-testid="sync-instruments-button" variant="outline" disabled={!!busy} onClick={() => run("sync", "/admin/instruments/sync", "Instrument master refreshed")}
          className="border-slate-700 bg-slate-900 text-slate-200 hover:bg-slate-800">
          {busy === "sync" ? <Loader2 className="h-4 w-4 animate-spin" /> : <><DatabaseZap className="mr-1.5 h-4 w-4" /> Sync instruments now</>}
        </Button>
        <Button data-testid="reconnect-stream-button" variant="outline" disabled={!!busy} onClick={() => run("rc", "/admin/stream/reconnect", "Stream restarted")}
          className="border-slate-700 bg-slate-900 text-slate-200 hover:bg-slate-800">
          {busy === "rc" ? <Loader2 className="h-4 w-4 animate-spin" /> : <><PlugZap className="mr-1.5 h-4 w-4" /> Restart stream</>}
        </Button>
      </div>
      <p className="text-[11px] text-slate-500">The instrument master also refreshes automatically every trading morning; expired contracts are dropped from subscriptions.</p>
    </div>
  );
};
